// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"style__backToTop__EVV0n"};